import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const imApi = {
  getCsRobotInfo(query) {
    return http.get(API_URLS.IM_ROBOT_INFO, {query});
  },
  csEvaluation(params) {
    return http.post(API_URLS.IM_CS_EVALUATION, {params});
  },
};
